<template>
  <div class="smartbanner__container">
    <transition name="smartbanner-toggle">
      <div
        class="smartbanner__dummy"
        :style="{ height }"
        v-if="active" />
    </transition>
    <transition name="smartbanner-toggle">
      <div
        class="smartbanner"
        v-if="active">
        <div
          class="smartbanner__body"
          ref="body">
          <div
            class="smartbanner__close"
            @click="onLocalCloseClick" />
          <div class="smartbanner__logo-container">
            <div class="smartbanner__logo" />
          </div>

          <div class="smartbanner__content">
            <div class="smartbanner__title">
              {{ $t("appName") }}
            </div>
            <div class="smartbanner__description">
              <div class="smartbanner__rating">
                <rating-stars
                  :modifiers="['smartbanner']"
                  extra-classes="smartbanner__rating-stars"
                  :mark="rating" />
                <span class="smatbanner__reatings-count">
                  ({{ ratingsCount }})
                </span>
              </div>

              <div class="smartbanner__price">
                <span class="smartbanner__free">
                  {{ $t("price") }}
                </span>
                <span class="smartbanner__store">
                  {{ storeLabel }}
                </span>
              </div>
            </div>
          </div>
          <a
            class="smartbanner__cta"
            @click="onLocalCloseClick"
            :href="storeLink">
            {{ $t("cta") }}
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import RatingStars from "/features/smartbanner/components/rating_stars";
export default {
  components: { RatingStars },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    platform: {
      type: String,
      default: "ios"
    },
    rating: {
      type: Number,
      default: 5.0
    },
    ratingsCount: {
      type: [Number, String],
      default: 0
    },
    onClose: {
      type: Function,
      default: null
    },
    storeLink: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      active: false,
      height: 0
    };
  },
  computed: {
    storeLabel() {
      return this.$t("store")[this.platform];
    }
  },
  watch: {
    active() {
      this.$nextTick(this.setDummyHeight);
    }
  },
  mounted() {
    this.active = true;
  },
  methods: {
    onLocalCloseClick() {
      this.active = false;
      if (this.onClose) {
        this.onClose();
      }
    },
    setDummyHeight() {
      this.height = this.active ? `${this.$refs.body.clientHeight}px` : 0;
    }
  },
  i18n: {
    messages: {
      en: {
        appName: "Blinkist",
        price: "Free",
        store: {
          ios: "on the App Store",
          android: "on Google Play"
        },
        cta: "Install now"
      },
      de: {
        appName: "Blinkist",
        price: "Kostenlos",
        store: {
          ios: "Im App Store",
          android: "Im Google Play"
        },
        cta: "Installieren"
      }
    }
  }
};
</script>

<style lang="scss">
.smartbanner {
  $background-color: #f9f9f9;
  $shadow-color: #e5e5e5;

  @include font-family(sans-serif);

  position: fixed;
  top: 0;
  z-index: 2000;

  display: flex;
  align-items: flex-end;
  width: 100%;
  overflow: hidden;

  background-color: $background-color;
  border-bottom: $shadow-color solid 1px;

  &__body {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    /* stylelint-disable-next-line unit-blacklist */
    padding: rem(10px) rem(14px);
  }

  &__close {
    flex-shrink: 0;
    width: rem(11px);
    height: rem(11px);
    margin-right: $base;

    background-image: url("~@images/smartbanner/close.svg");
  }

  &__logo-container {
    /* stylelint-disable-next-line unit-blacklist */
    flex-basis: rem(62px);
  }

  &__logo {
    position: relative;

    /* stylelint-disable-next-line unit-blacklist */
    flex-basis: rem(62px);
    padding-top: 100%;

    background-color: $bk-color-white;
    background-image: url("~@images/smartbanner/logo.svg");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border: rgba($grey-light, 0.5) solid 1px;
    border-radius: rem(15px);
  }

  &__content {
    flex-grow: 1;
    margin-left: $base;
  }

  &__title {
    @include font-style(h5);

    margin-bottom: base(0.5);

    color: $black;
  }

  &__description {
    @include font-style(legal);
    @include font-weight(medium);

    color: $grey;
  }

  &__rating {
    display: flex;
    margin-bottom: base(0.5);
  }

  &__rating-stars {
    width: rem(55px);
    margin-right: base(0.5);
  }

  &__free {
    text-transform: uppercase;

    &:after {
      content: "–";
    }
  }

  &__cta {
    @include font-style(caption);
    @include font-weight(bold);

    margin-left: $base;
    /* stylelint-disable-next-line unit-blacklist */
    padding: rem(7px) rem(6px) rem(8px);

    color: $green;
    white-space: nowrap;
    text-transform: uppercase;

    border: 1px solid $green;
    border-radius: 3px;
  }
}

.smartbanner-toggle-enter-active,
.smartbanner-toggle-leave-active {
  max-height: rem(100px);

  transition: max-height 0.25s;
}

.smartbanner-toggle-enter,
.smartbanner-toggle-leave-to {
  max-height: 0;
}
</style>
